var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrokenLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "919 3487 100 101.232",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #4acfd9;\n      }\n\n      .cls-3 {\n        fill: #0295aa;\n      }\n\n      .cls-4 {\n        fill: #fd6a33;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "broken-link",
    transform: "translate(931.998 3496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    className: "cls-1",
    d: "M50,0A50,50,0,1,1,0,50,50,50,0,0,1,50,0Z",
    transform: "translate(-12.998 -9)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    className: "cls-2",
    d: "M39.592,18.417,25.554,4.378A14.972,14.972,0,0,0,4.38,25.553L18.418,39.591A14.972,14.972,0,0,0,39.592,18.417ZM20.29,9.643,34.328,23.681A7.528,7.528,0,1,1,23.682,34.327l-7.019-7.019h0L9.644,20.289A7.527,7.527,0,0,1,20.29,9.643Z",
    transform: "translate(-0.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    className: "cls-2",
    d: "M270.185,249.012l-14.038-14.038a14.972,14.972,0,0,0-21.174,21.174l14.038,14.038a14.972,14.972,0,0,0,21.174-21.174Zm-15.91,15.91-7.019-7.019-7.019-7.019a7.527,7.527,0,0,1,10.645-10.646l14.038,14.038a7.527,7.527,0,0,1-10.645,10.646Z",
    transform: "translate(-71.154 -272.644) rotate(25)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    className: "cls-3",
    d: "M165.157,159.9,135.21,129.956a3.722,3.722,0,0,0-5.264,5.264l29.948,29.948a3.722,3.722,0,1,0,5.264-5.264Z",
    transform: "translate(-108.72 -108.732)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(46.814 12.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    className: "cls-4",
    d: "M334.72,123.36a1.241,1.241,0,0,1-.878-2.118l6.948-6.948a1.241,1.241,0,0,1,1.755,1.755L335.6,123A1.237,1.237,0,0,1,334.72,123.36Z",
    transform: "translate(-328.185 -108.859)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    className: "cls-4",
    d: "M300.839,93.783a1.241,1.241,0,0,1-1.241-1.241V82.716a1.241,1.241,0,0,1,2.482,0v9.827A1.241,1.241,0,0,1,300.839,93.783Z",
    transform: "translate(-299.598 -81.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    className: "cls-4",
    d: "M358.583,194.764h-9.826a1.241,1.241,0,0,1,0-2.482h9.826a1.241,1.241,0,0,1,0,2.482Z",
    transform: "translate(-340.029 -174.968)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenLink);
export default __webpack_public_path__ + "static/media/broken-link.b7b3df43bc505b2d2abd047dfc392ad3.svg";
export { ForwardRef as ReactComponent };